import '@b2ag/auth/style.css'
import { useAuthService } from '@b2ag/auth'
import { i18n } from '@b2ag/locale'
import { locationStorage } from '../../services'

import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- CONTEXTS - AUTHENTIFICATION ------- */

export const authRoutes = [
  {
    path: '/oauth/login',
    name: 'login',
    meta: {
      doNotStoreRoute: true,
      oauthWorkflow: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login()
      },
    },
    beforeEnter(to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (to.query.redirectTo) {
        locationStorage.storeLocation(to.query.redirectTo as string)
      }
      next()
    },
  },
  {
    path: '/oauth/login/smag',
    name: 'smag-sso',
    meta: {
      oauthWorkflow: true,
      doNotStoreRoute: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SMAG_SSO,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login({ target: 'SMAG' })
      },
    },
  },
  {
    path: '/oauth/login/extranet',
    name: 'login-extranet',
    meta: {
      oauthWorkflow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login({ target: 'EXTRANET' })
      },
    },
    beforeEnter(to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      localStorage.setItem('extranetPartnerId', to.query.partner as string)
      localStorage.setItem('extranetMembershipNumber', to.query.membershipNumber as string)
      next()
    },
  },
  {
    path: '/oauth/callback',
    name: 'auth-callback',
    component: () => import('@b2ag/auth/auth-views').then((m) => m.VAuthCallback),
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      oauthWorkflow: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.OAUTH_CALLBACK,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    props: () => {
      return {
        targetRoute: locationStorage.afterLoginPath,
        router: {
          push: (data: string) => Promise.resolve(window.location.replace(data)),
        },
        auth: useAuthService(),
        i18n,
      }
    },
    beforeEnter(to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (to.query.error_description) {
        return next({ name: 'auth-callback-error', query: to.query })
      }
      next()
    },
  },
  {
    path: '/oauth/error',
    name: 'auth-callback-error',
    component: () => import('@b2ag/micro-front-auth-callback-error/app'),
    props: () => ({
      microFrontName: 'auth-callback-error',
      viewName: 'default',
    }),
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      private: false,
      oauthWorkflow: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
  },
]
